import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../../public/reno_static/video-marketing-guide/InterSF-v3.woff2%22,%22weight%22:%22100%20900%22,%22display%22:%22swap%22,%22variable%22:%22--font-guide-inter%22}],%22variableName%22:%22guideInter%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'guideInter', 'guideInter Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
